<template>
  <v-card
    :color="$vuetify.theme.dark ? 'grey darken-3' : '#F7F7F7'"
    class="pl-2 d-flex elevation-4"
    height="100%"
  >
    <v-card-text class="font-weight-light px-0 pt-0 pb-0 ml-1">
      {{ getSortingLabel }}
      <div v-for="detail in summaryLines" :key="detail">{{ detail }}<br /></div>
      <v-data-table
        dense
        hide-default-footer
        :headers="headers"
        :items="launches"
        class="mr-3"
        height="570"
      >
        <template slot="item" slot-scope="row">
          <tr class="pa-0">
            <td class="px-1" v-for="header in headers" :key="header.value">
              <div
                v-for="(detail, index) in row.item[header.value]"
                :key="index"
              >
                {{ detail }}<br />
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'deployment-scenario-details',

  props: {
    index: {
      type: Number,
      default: 0
    },
    scenarios: {
      type: Array,
      default: null
    }
  },

  data() {
    return {}
  },

  mounted() {},

  computed: {
    ...mapGetters(['currentResultsLog']),

    getSortingLabel() {
      const sortingDirection = this.currentResultsLog?.results?.sortingDirection
      const resultSorting = this.currentResultsLog?.results?.resultSorting
      if (!resultSorting) {
        return ''
      }
      const resultSortingName = resultSorting.split('_').join(' ')
      return `Results sorted by ${sortingDirection.toLowerCase()} ${resultSortingName.toLowerCase()}.`
    },
    summaryLines() {
      if (this.scenarios == null || this.scenarios[this.index] == null) {
        return []
      }
      let lines = this.scenarios[this.index].summary.split('<br/>')
      lines[0] = '#' + (this.index + 1) + ' ' + lines[0]
      return lines
    },
    headers() {
      if (this.scenarios == null || this.scenarios[this.index] == null) {
        return []
      }
      let headers = [{ value: 'launch', text: 'Launch', sortable: false }]
      for (let i = 0; i < this.scenarios[this.index].numberOfPlanes; i++) {
        headers.push({
          value: '' + i,
          text: 'Plane ' + (i + 1),
          sortable: false
        })
      }
      return headers
    },

    launches() {
      let launches = []
      if (this.scenarios == null || this.scenarios[this.index] == null) {
        return launches
      }
      for (let i = 0; i < this.scenarios[this.index].numberOfLaunches; i++) {
        let launch = {}
        launch['launch'] = this.scenarios[this.index].bookings[i].launchDetails
        for (let j = 0; j < this.scenarios[this.index].numberOfPlanes; j++) {
          let spacecraftsInPlane =
            this.scenarios[this.index].bookings[i].numberOfSpacecraftsPerPlane[
              j
            ]
          if (spacecraftsInPlane > 0) {
            let lines =
              this.scenarios[this.index].bookings[i].launchDetailsPerPlane[j]
            if (!lines[0].includes('spacecraft')) {
              const suffix = spacecraftsInPlane > 1 ? 's' : ''
              lines.unshift(spacecraftsInPlane + ' spacecraft' + suffix)
            }
            launch[j] = lines
          } else {
            launch[j] = []
          }
        }
        launches.push(launch)
      }
      return launches
    }
  },

  methods: {}
}
</script>

<style scoped></style>
